import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VehicleDetails from "./VehicleDetails";

const mapStateToProps = (state) => ({
  enums: state.enums,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(VehicleDetails);
